import { GET_USER_OFFICES, GET_OFFICE, GET_ALL_OFFICES, OFFICE_LOADING } from "../actions/types";

const initialState = {
  userOffices: null,
  office: null,
  allOffices: null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case OFFICE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_USER_OFFICES:
      return {
        ...state,
        userOffices: action.payload,
        loading: false,
      };
    case GET_OFFICE:
      return {
        ...state,
        office: action.payload,
        loading: false,
      };
    case GET_ALL_OFFICES:
      return {
        ...state,
        allOffices: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
